<template>
  <Modal
    :value="showModal"
    :title="'添加网格长'"
    :mask-closable="false"
    width="600"
    @on-cancel="ManagerQuxiao"
  >
    <div class="box table-box">
      <div class="right-text">姓名</div>
      <AutoComplete
        v-model="autoValue"
        @on-search="searchManger"
        @on-select="selectAuto"
        :placeholder="'请输入网格长姓名'"
      >
        <Option
          v-for="(item, index) in userlist"
          :value="index"
          :key="index"
        >{{ item.realName }}({{ item.userName || "无昵称" }})</Option>
      </AutoComplete>
    </div>
    <div class="box table-box">
      <div class="right-text">头像</div>
      <div class="form-avatar">
        <img
          class="form-avatar_img"
          :src="imgArr && imgArr[0]&& imgArr[0].path || require('@/assets/images/default.png')"
          title="用户头像"
        />
        <div class="photoKuang">
          <i class="iconfont icon-bianji1 photo-bianji"></i>
        </div>
        <div class="uploadKuang">
          <upload-img
            :imgArr="imgArr"
            :fixedNumber="[1, 1]"
            :imgNumber="1"
            :imgWidth="80"
            :imgHeight="80"
            :isActive="true"
            :isEditorBox="true"
            @saveImg="saveImg"
          >
            <div style="height:80px;width:80px;margin-top:100px"></div>
          </upload-img>
        </div>
      </div>
    </div>
    <div class="box table-box">
      <div class="right-text">职务</div>
      <Select v-model="proTitleId" placeholder="请选择职务" label-in-value @on-change="onJobChange">
        <Option v-for="item in jobList" :key="item.value" :value="item.value">{{item.label}}</Option>
      </Select>
      <!-- <Input v-model="proTitle" placeholder="请输入职务" /> -->
    </div>
    <div class="box table-box">
      <div class="right-text">工作电话</div>
      <Input v-model="phoneNO" placeholder="请输入电话号码" />
    </div>
    <div slot="footer">
      <Button type="text" @click="ManagerQuxiao">取消</Button>
      <Button type="primary" @click="addMember">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadImg from "../../../components/uploadImg";
export default {
  props: {
    showModal: {
      //控制是否显示搜索弹窗
      type: Boolean,
      default: false,
    },
    passLeader: null,
    gridId: "",
  },
  data() {
    return {
      autoValue: "",
      selectMember: "",
      userlist: [], //搜索弹窗中搜索结果
      proTitle: "", // 要添加人员的职位
      proTitleId: "751", // 职位对应的id
      phoneNO: "",
      id: "",
      headPicUrl: "",
      valueChange: false,
      page: 1,
      jobList: [],
      imgArr: [],
    };
  },
  computed: {},
  watch: {
    passLeader(newValue, oldValue) {
      if (newValue) {
        console.log(newValue);
        this.autoValue = newValue.userName;
        this.proTitle = newValue.proTitle;
        this.proTitleId = +newValue.proTitleId;
        this.phoneNO = newValue.phoneNO;
        this.realName = newValue.realName;
        this.userName = newValue.userName;
        this.id = newValue.id;
        this.headPicUrl = newValue.headPicUrl;
        this.imgArr = [
          {
            id: 0,
            path: this.headPicUrl,
          },
        ];
        // console.log(this.imgArr)
        this.selectMember = {
          headPicUrl: newValue.headPicUrl,
          userName: newValue.userName,
          unionId: newValue.unionId,
        };
        console.log(this.selectMember);
      } else {
        this.autoValue = "";
        this.proTitle = "";
        this.proTitleId = "";
        this.phoneNO = "";
        this.selectMember = "";
        this.id = "";
        this.realName = "";
        this.imgArr = [];
        this.headPicUrl = "";
      }
    },
  },
  methods: {
    saveImg(data) {
      console.log(this.imgArr);
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    // 获取职务列表
    getJobList() {
      let url = this.urlobj.griderJobList;
      console.log(url);
      this.$get(url)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);

          this.jobList = res.rows.map((item) => ({
            value: item.id,
            label: item.dicName,
          }));
        })
        .catch((e) => {
          alert(e.message);
        });
    },
    // job 发生变化
    onJobChange(e) {
      if (!e) return;
      console.log(e);
      this.proTitle = e.label;
      this.proTitleId = e.value;
    },
    // 添加人员
    addMember() {
      var that = this;
      // addGridUser
      let url = this.urlobj.addGridUser();
      var selectMember = "";
      if (this.valueChange) {
        console.log(that.userlist);
        that.userlist.forEach((item) => {
          if (
            item.unionId == that.selectMember.unionId &&
            (item.realName == that.autoValue || item.userName == that.autoValue)
          ) {
            selectMember = item;
          }
        });
      } else {
        selectMember = this.selectMember;
      }
      // if (!selectMember) {
      //   that.$Message.warning("请选择网格长");
      //   return;
      // }
      let data = {
        gridId: this.gridId,
        proTitle: this.proTitle,
        proTitleId: this.proTitleId,
        // unionId: selectMember.unionId, // 目前是单选 就取 0
        // userName: selectMember.realName || this.userName,
        userName: this.autoValue,
        phoneNO: parseInt(this.phoneNO),
        headPicUrl: this.imgArr[0] && this.imgArr[0].path || "",
        isExcellent: 0,
      };
      if (selectMember) {
        data.unionId = selectMember.unionId;
        data.userlist = selectMember.realName || this.userName;
        // data.headPicUrl = this.selectMember.headPicUrl
      }
      if (this.id) {
        data.id = this.id;
      }
      console.log("data", data);
      console.log(that.userlist);
      this._showSpin();
      this.$post(url, data)
        .then((res) => {
          this.page = 1;
          this.valueChange = false;
          if (res.isSucceed) {
            // 拼接用户数据
            if (that.id) this.$Message.success("修改成功");
            else this.$Message.success("添加成功");
            let _t = {
              headPicUrl: this.imgArr[0] && this.imgArr[0].path || "",
              realName: that.autoValue,
              unionId: selectMember.unionId,
              id: res.newPrimaryKeys.id,
              proTitle: that.proTitle,
              proTitleId: that.proTitleId,
              phoneNO: that.phoneNO,
              change: that.id ? true : false,
            };
            this.$emit("addMember", _t);
            this._initProp();
          }
        })
        .catch((e) => console.log(e));
    },
    // 取消按钮
    modalCancel() {
      this._initProp();
    },
    _searchManger(value) {
      if (this.page != 1 || !this.id) this.valueChange = true;
      var that = this;
      var url = this.urlobj.gridUser;
      this.$post(url, {
        pageNum: 1,
        pageSize: 10,
        userName: value,
        gridId: this.gridId,
      }).then((res) => {
        that.page++;
        that.isData = false;
        var list = [];
        res.rows.map((item) => {
          list.push({
            realName: item.realName,
            headPicUrl: item.headPicUrl,
            userName: item.userName,
            unionId: item.unionId,
            id: item.id,
          });
        });
        that.userlist = list;
        console.log(this.imgArr);
      });
    },
    selectAuto(value) {
      var autoValue = this.userlist[value];
      this.$nextTick(() => {
        this.autoValue = autoValue.realName || autoValue.userName; // 更新地点
        this.selectMember = autoValue;
        this.imgArr = [
          {
            id: 0,
            path: autoValue.headPicUrl,
          },
        ];
      });
    },
    // 初始化数据
    _initProp() {
      this.proTitle = "";
      this.modelInput = "";
      this.userlist = [];
      this.$emit("modalCancel");
    },
    _showSpin() {
      this.showSpin = true;
    },
    _hideSpin() {
      this.showSpin = false;
    },
    ManagerQuxiao() {
      this.$emit("quxiao");
    },
  },
  components: {
    uploadImg,
  },
  mounted() {},
  created() {
    this.searchManger = this._.debounce(this._searchManger, 500);
    this.getJobList();
  },
};
</script>
<style lang="less" scoped>
.modelInput {
  margin-top: 10px;
}
.searchcard-wrapper {
  position: relative;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  overflow-y: scroll;
}
.search-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 150px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}

.img img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.search-name {
  margin-top: 10px;
  color: #4b4b4b;
  font-weight: 600;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.searchcard-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}

.table-box {
  align-items: center;
  margin-bottom: 30px;
}
.right-text {
  width: 70px;
  text-align: right;
  margin-right: 10px;
}

.form-avatar {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  &:hover .photoKuang {
    display: flex;
  }
}
.form-avatar_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.photoKuang {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  .photo-bianji {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
}

/deep/ #uploads {
  top: 100px !important;
  height: 80px !important;
  // background: red;
}

.uploadKuang {
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
}
</style>
